<template>
  <div class="wl-navigation d-block d-xl-inline-block">
 

      <div class="wl-side-nav badge badge-pill badge-primary ">
        <div class="wl-side-nav__inner d-flex align-items-center flex-xl-column justify-content-between pb-lg-4 pt-xl-5 pb-xl-5 pr-5 pl-5 pr-xl-0 pl-xl-0">
          <b-link
              @click="$root.$emit('track', {source: null, target: item.link, button: $t(item.title)})"
              :to="item.link"
              class="wl-side-nav__item mt-2 mb-2"
              v-for="item in navitems"
              v-bind:key="item.id"
              :alt="$t(item.title)"
              >
              <font-awesome-icon :icon="item.icon" />
              <span class="wl-side-nav__tooltip bg-primary p-4 d-lg-block d-none">
                  {{ $t(item.title) }}
                  <span class="arrow d-block bg-primary"></span>
              </span>
              <!--<span class="wl-side-nav__item__subtitle">{{ $t(item.title) }}</span>-->
          </b-link> 
        </div>

        
      </div>

  </div>
  

</template>

<script>

import { mapGetters } from 'vuex';
//import * as CONFIG from '@/wl-config/wl-app-config';
const CONFIG =  require(`@/wl-config/${process.env.VUE_APP_WL_FOLDER}/wl-app-config`)
const items = [
  { id: 1, icon: CONFIG.WLCONFG.ICON_NAVIGATION_DASHBOARD, link: '/dashboard', title: 'NAV_LINK_TEXT_DASHBOARD', active:true },
  { id: 2, icon: CONFIG.WLCONFG.ICON_NAVIGATION_MY_PRODUCTS, link: '/myProducts', title: 'NAV_LINK_TEXT_MY_PRODUCTS', active: true  },
  { id: 4,  icon: CONFIG.WLCONFG.ICON_NAVIGATION_ACADEMY, link: '/academylessons', title: 'NAV_LINK_TEXT_ACADEMY', active:true  },
  { id: 5,  icon: CONFIG.WLCONFG.ICON_NAVIGATION_BLOG, link: '/blogarticles', title: 'NAV_LINK_TEXT_BLOG', active:  CONFIG.WLCONFG.SHOW_BLOG},
  { id: 6,  icon: CONFIG.WLCONFG.ICON_NAVIGATION_AI, link: '/ai-tools', title: 'NAV_LINK_TEXT_AI', active:  CONFIG.WLCONFG.SHOW_AI}
];


//{ id: 3,  icon: CONFIG.WLCONFG.ICON_NAVIGATION_STATISTICS, link: '/statistic', title: 'NAV_LINK_TEXT_STATISTICS'  },

export default {
  name: "NavigationBar",
  data() {
    return {
      navitems: items.filter( (item) => item.active),
      currentRoute: {},
    }
  },
  mounted() {
    this.currentRouteD();
  },
  computed: {
    ...mapGetters([
      'getUserLevel'
    ]),
  },
  methods: {
    currentRouteD() {
      this.currentRoute = this.$router.currentRoute;
    }
  }
}
</script>

<style scoped>


</style>